import { Box } from '@mui/system';
import styled from 'styled-components';

export const OrderApprovedScreenWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(100vh - 64px - 50px);
  text-align: center;
  ${(props) => props.fontFamily ?? 'Source Sans Pro'};
  overflow-y: scroll;
`;

export const OrderApprovedContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  width: 60%;
  box-sizing: border-box;
  font-family: inherit;

  @media (max-width: 768px) {
    width: 100%;
    padding: 20px;
  }
`;

export const LogoImage = styled.img`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
`;

export const OrderApprovedHeader = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 60px;
  background-color: var(--color-blue-primary);
  color: white;
  font-size: 17px;
  font-family: inherit;
`;

export const BoldText = styled(Box)`
  font-weight: bold;
  font-size: ${(props) => props.fontSize ?? '15px'};
  text-align: ${(props) => props.textAlign ?? 'center'};
  font-family: inherit;
`;

export const NormalText = styled(Box)`
  font-size: 15px;
  text-align: ${(props) => props.textAlign ?? 'center'};
  font-family: inherit;

  @media (max-width: 768px) {
    text-align: ${(props) =>
      props.keepTextAling ? props.textAlign : 'center'};
  } ;
`;

export const TextLink = styled.a`
  font-size: 15px;
  text-align: ${(props) => props.textAlign ?? 'center'};
  color: var(--color-blue-primary);
  cursor: pointer;
  font-family: inherit;
`;

export const QrCodeImage = styled.img`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 600px;
  height: 600px;

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
  }
`;

export const InfoRow = styled(Box)`
  display: flex;
  align-items: ${(props) => props.alignItems ?? 'center'};
  justify-content: flex-start;
  width: 100%;
  font-family: inherit;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const InfoColumn = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  font-family: inherit;
`;

export const StepImage = styled.img`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 250px;
  font-family: inherit;
  flex: 1;
`;

export const TextColumn = styled(Box)`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  justify-content: ${(props) => props.justify ?? 'center'};
  width: 100%;
  height: 100%;
  font-family: inherit;
  padding: ${(props) => props.padding ?? '0px'};

  @media (max-width: 768px) {
    justify-content: center;
    align-items: center;
  }
`;
